<template>
    <div class="exploding-cube loader-wrapper">
        <div class="cube-piece" style="--x: -1; --y: -1"></div>
        <div class="cube-piece" style="--x: 0; --y: -1"></div>
        <div class="cube-piece" style="--x: 1; --y: -1"></div>
        <div class="cube-piece" style="--x: -1; --y: 0"></div>
        <div class="cube-piece" style="--x: 0; --y: 0"></div>
        <div class="cube-piece" style="--x: 1; --y: 0"></div>
        <div class="cube-piece" style="--x: -1; --y: 1"></div>
        <div class="cube-piece" style="--x: 0; --y: 1"></div>
        <div class="cube-piece" style="--x: 1; --y: 1"></div>
    </div>
</template>

<script>
export default {
    name: 'CubeLoader', 
    data() {
        return {           
        }
    },
}
</script>

<style scoped>
.loader-wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
    padding-top: 10dvh;
    min-height: 30vh;
}

.exploding-cube {
    display: grid;
    grid-template-columns: repeat(3, 20px);
    grid-template-rows: repeat(3, 20px);
    gap: 2px;
}

.cube-piece {
    width: 18px;
    height: 18px;
    background: #333;
    animation: explodeRebuild 2.5s infinite ease-in-out;
    animation-delay: calc((var(--x) + 1 + (var(--y) + 1) * 3) * 0.05s);
}

@keyframes explodeRebuild {
    0% {
        transform: translate(0, 0) scale(1);
        opacity: 1;
    }

    40% {
        transform: translate(calc(var(--x) * 25px), calc(var(--y) * 25px)) scale(0.6);
        opacity: 0;
    }

    60% {
        transform: translate(calc(var(--x) * 25px), calc(var(--y) * 25px)) scale(0.6);
        opacity: 0;
    }

    100% {
        transform: translate(0, 0) scale(1);
        opacity: 1;
    }
}
</style>